import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "./api";

export default function useHousehold(role) {
    const [data, setData] = useState({ children: [], chores: [], rewards: [] });
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);
    const [busy, setBusy] = useState(false);
    const mounted = useRef(true), mutating = useRef(false), version = useRef(0);
    const url = role === "child" ? "/auth/child/household" : "/household";
    const refresh = useCallback(async () => {
        const current = version.current;
        try {
            const response = await api.get(url);
            if (mounted.current && current === version.current && !mutating.current) { setData(response.data); setError(""); }
        } catch (failure) { if (mounted.current) setError(failure?.response?.data?.detail || "The working desk could not sync. Please retry."); }
        finally { if (mounted.current) setLoading(false); }
    }, [url]);
    useEffect(() => {
        mounted.current = true; void refresh();
        const timer = setInterval(refresh, 15000);
        window.addEventListener("focus", refresh); window.addEventListener("shadowGroveHouseholdUpdated", refresh);
        window.addEventListener("shadowGroveMeritsUpdated", refresh);
        return () => { mounted.current = false; clearInterval(timer); window.removeEventListener("focus", refresh); window.removeEventListener("shadowGroveHouseholdUpdated", refresh); window.removeEventListener("shadowGroveMeritsUpdated", refresh); };
    }, [refresh]);
    const act = async (method, path, payload) => {
        if (mutating.current) return false;
        mutating.current = true; version.current += 1; setBusy(true); setError("");
        try {
            const result = await api[method](path, payload);
            // Discard reads started while the previous balance was still being changed.
            version.current += 1;
            if (mounted.current) setData(result.data);
            mutating.current = false;
            window.dispatchEvent(new CustomEvent("shadowGroveHouseholdUpdated"));
            window.dispatchEvent(new CustomEvent("shadowGroveMeritsUpdated"));
            return true;
        } catch (failure) { if (mounted.current) setError(failure?.response?.data?.detail || "The change could not be saved. Please retry."); return false; }
        finally { mutating.current = false; if (mounted.current) setBusy(false); }
    };
    return { data, error, loading, busy, act, refresh };
}
